/* eslint-disable */
// import auth from "@/middleware/auth";
export default[
  {
    path: '/inicio',
    name: 'home',
    component: () => import('@/views/home/index.vue'),
    // meta:{
    //   middleware: auth,
    // }
  },
  // *===============================================---*
  // *--------- LOCALES ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/locales/listar',
    name: 'locals-list',
    component: () => import('@/views/locales/locales-list/index.vue'),
    meta: {
      pageTitle: 'Tiendas y Almacenes',
      breadcrumb: [
        {
          text: 'Listar',
          active: true,
        },
      ],
    },
  },

  {
    path: '/locales/comprobantes/:id',
    name: 'locals-voucher',
    component: () => import('@/views/locales/numeral/index.vue'),
    meta: {
      pageTitle: 'Tipo de comprobantes',
      breadcrumb: [
        {
          text: 'Listado',
          active: true,
        },
      ],
    },
  },
  // *===============================================---*
  // *--------- USER ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/usuarios/listar',
    name: 'users-list',
    component: () => import('@/views/usuarios/usuarios-list/index.vue'),
    meta: {
      pageTitle: 'Lista de usuarios',
      breadcrumb: [
        {
          text: 'Listar',
          active: true,
        },
      ],
    },
  },
  
  // *===============================================---*
  // *--------- ROLE ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/roles/listar',
    name: 'roles-list',
    component: () => import('@/views/roles/index.vue'),
    meta: {
      pageTitle: 'Lista de roles',
      breadcrumb: [
        {
          text: 'Listar',
          active: true,
        },
      ],
    },
  },
  {
    path: '/roles/menu/:id',
    name: 'roles-menu',
    component: () => import('@/views/roles/roles-asignación/index.vue'),
    meta: {
      pageTitle: 'Asignar Menu',
      breadcrumb: [
        {
          text: 'Asignar',
          active: true,
        },
      ],
    },
  },

  // {
  //   path: '/usuarios/editar/:id',
  //   name: 'users-edit',
  //   component: () => import('@/views/usuarios/usuarios-edit/index.vue'),
  //   meta: {
  //     pageTitle: 'Editar usuario',
  //     breadcrumb: [
  //       {
  //         text: 'Usuarios',
  //         to: '/users/list',
  //       },
  //       {
  //         text: 'Editar',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/usuarios/asignacion',
  //   name: 'users-asignacion',
  //   component: () => import('@/views/usuarios/usuarios-asignacion/index.vue'),
  //   meta: {
  //     pageTitle: 'Asignar Permisos',
  //     breadcrumb: [
  //       {
  //         text: 'Usuarios',
  //         to: '/users/list',
  //       },
  //       {
  //         text: 'Asignacion',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/usuarios/agregar',
  //   name: 'users-add',
  //   component: () => import('@/views/usuarios/usuarios-add/index.vue'),
  //   meta: {
  //     pageTitle: 'Agregar usuario',
  //     breadcrumb: [
  //       {
  //         text: 'Usuarios',
  //         to: '/users/list',
  //       },
  //       {
  //         text: 'Agregar',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //   path: '/usuarios/asignacion',
  //   name: 'users-asign',
  //   component: () => import('@/views/usuarios/usuarios-asignacion/index.vue'),
  //   meta: {
  //     pageTitle: 'Asignación de roles',
  //     breadcrumb: [
  //       {
  //         text: 'Usuarios',
  //         to: '/users/list',
  //       },
  //       {
  //         text: 'Asignación',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // *===============================================---*
  // *--------- INVENTARIO ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/inventario/stock-total',
    name: 'stock-total-list',
    component: () => import('@/views/inventario/stock-total/index.vue'),
    meta: {
      pageTitle: 'Lista Total del Inventario',
      breadcrumb: [
        {
          text: 'Listar',
          active: true,
        },
      ],
    },
  },
  {
    path: '/inventario/stock-perdido',
    name: 'stock-perdido',
    component: () => import('@/views/inventario/stock-perdido/index.vue'),
    meta: {
      pageTitle: 'Lista Total del Inventario Perdido',
      breadcrumb: [
        {
          text: 'Listar',
          active: true,
        },
      ],
    },
  },
  {
    path: '/inventario/listar/:autopartId',
    name: 'stock-detail',
    component: () => import('@/views/inventario/stock-list/detail/index.vue'),
    meta: {
      pageTitle: 'Lista Detallada del Stock',
      breadcrumb: [
        {
          text: 'Listar',
          active: true,
        },
      ],
    },
  },
  {
    path: '/inventario/listar',
    name: 'stock-list',
    component: () => import('@/views/inventario/stock-list/index.vue'),
    meta: {
      pageTitle: 'Lista de Inventario',
      breadcrumb: [
        {
          text: 'Listar',
          active: true,
        },
      ],
    },
  },
  {
    path: '/inventario/reajuste',
    name: 'stock-reajuste',
    component: () => import('@/views/inventario/stock-list/reajuste.vue'),
    meta: {
      pageTitle: 'Reajuste de Inventario',
      breadcrumb: [
        {
          text: 'Reajuste',
          active: true,
        },
      ],
    },
  },
  {
    path: '/inventario/entrada',
    name: 'stock-entrada',
    component: () => import('@/views/inventario/inventario-entrada/index.vue'),
    meta: {
      pageTitle: 'Mov. Interno',
      breadcrumb: [
        {
          text: 'Inventario',
          to: '/stock/list',
        },
        {
          text: 'Mov. Interno',
          active: true,
        },
      ],
    },
  },
  {
    path: '/inventario/entrada/historial/',
    name: 'historial-entrada',
    component: () => import('@/views/inventario/inventario-entrada/historial/index.vue'),
    meta: {
      pageTitle: 'Historial de Registros',
      breadcrumb: [
        {
          text: 'Historial',
          to: '/stock/list',
        },
        {
          text: 'Lista de registros',
          active: true,
        },
      ],
    },
  },
  {
    path: '/inventario/entrada/bandeja/',
    name: 'bandeja-entrada',
    component: () => import('@/views/inventario/inventario-entrada/bandeja/index.vue'),
    meta: {
      pageTitle: 'Bandeja de Movimientos',
      breadcrumb: [
        {
          text: 'Bandeja',
          to: '/stock/list',
        },
        {
          text: 'Lista de movimientos',
          active: true,
        },
      ],
    },
  },
  {
    path: '/inventario/entrada/bandeja-destino/',
    name: 'bandeja-destino',
    component: () => import('@/views/inventario/inventario-entrada/bandeja-destino/index.vue'),
    meta: {
      pageTitle: 'Bandeja de Movimiento por Destino',
      breadcrumb: [
        {
          text: 'Bandeja',
          to: '/stock/list',
        },
        {
          text: 'Lista de movimientos por destino',
          active: true,
        },
      ],
    },
  },
  {
    path: '/inventario/entrada/bandeja-observado/',
    name: 'bandeja-observado',
    component: () => import('@/views/inventario/inventario-entrada/bandeja-observado/index.vue'),
    meta: {
      pageTitle: 'Bandeja de Movimientos Observados',
      breadcrumb: [
        {
          text: 'Bandeja',
          to: '/stock/list',
        },
        {
          text: 'Lista de movimientos observados',
          active: true,
        },
      ],
    },
  },
  {
    path: '/inventario/entrada/detalle/:id',
    name: 'detalle-mov',
    component: () => import('@/views/inventario/inventario-entrada/detalle-entrada.vue'),
    meta: {
      pageTitle: 'Detalle Mov. Interno',
      breadcrumb: [
        {
          text: 'Mov. Interno',
          to: '/inventario/entrada',
        },
        {
          text: 'Detalle Movimiento',
          active: true,
        },
      ],
    },
  },
  {
    path: '/inventario/entrada/editar/:id',
    name: 'editar-mov',
    component: () => import('@/views/inventario/inventario-entrada/editar-entrada.vue'),
    meta: {
      pageTitle: 'Editar Mov. Interno',
      breadcrumb: [
        {
          text: 'Mov. Interno',
          to: '/inventario/entrada',
        },
        {
          text: 'Editar Mov. Interno',
          active: true,
        },
      ],
    },
  },
  {
    path: '/inventario/entrada/detalle/editar/:id',
    name: 'detalle-editar-mov',
    component: () => import('@/views/inventario/inventario-entrada/editar-observado.vue'),
    meta: {
      pageTitle: 'Editar Detalle Mov. Interno',
      breadcrumb: [
        {
          text: 'Mov. Interno',
          to: '/inventario/entrada',
        },
        {
          text: 'Editar Detalle Movimiento',
          active: true,
        },
      ],
    },
  },
  {
    path: '/inventario/entrada/aceptar/:id',
    name: 'detalle-mov',
    component: () => import('@/views/inventario/inventario-entrada/detalle-aceptar.vue'),
    meta: {
      pageTitle: 'Aceptar Mov. Interno',
      breadcrumb: [
        {
          text: 'Mov. Interno',
          to: '/inventario/entrada',
        },
        {
          text: 'Aceptar Movimiento',
          active: true,
        },
      ],
    },
  },
  {
    path: '/inventario/entrada/observacion/aprobar/:id',
    name: 'observacion-aprobar',
    component: () => import('@/views/inventario/inventario-entrada/bandeja-observado/detalle-aprobado/index.vue'),
    meta: {
      pageTitle: 'Aprobar Observación Mov. Interno',
      breadcrumb: [
        {
          text: 'Mov. Interno',
          to: '/inventario/entrada',
        },
        {
          text: 'Aprobar Observación',
          active: true,
        },
      ],
    },
  },
  {
    path: '/inventario/entrada/observacion/:id',
    name: 'observacion-mov',
    component: () => import('@/views/inventario/inventario-entrada/bandeja-observado/detalle-observado/index.vue'),
    meta: {
      pageTitle: 'Observación Mov. Interno',
      breadcrumb: [
        {
          text: 'Mov. Interno',
          to: '/inventario/entrada',
        },
        {
          text: 'Observación',
          active: true,
        },
      ],
    },
  },
  {
    path: '/inventario/entrada/aceptar-destino/:id',
    name: 'detalle-mov',
    component: () => import('@/views/inventario/inventario-entrada/detalle-destino-aceptar.vue'),
    meta: {
      pageTitle: 'Aceptar Mov. Interno',
      breadcrumb: [
        {
          text: 'Mov. Interno',
          to: '/inventario/entrada',
        },
        {
          text: 'Aceptar Movimiento',
          active: true,
        },
      ],
    },
  },
  {
    path: '/inventario/salida',
    name: 'stock-salida',
    component: () => import('@/views/inventario/inventario-salida/index.vue'),
    meta: {
      pageTitle: 'Mov. Externo',
      breadcrumb: [
        {
          text: 'Inventario',
          to: '/stock/list',
        },
        {
          text: 'Mov. Externo',
          active: true,
        },
      ],
    },
  },
  {
    path: '/inventario/salida/editar/:id',
    name: 'editar-mov-ext',
    component: () => import('@/views/inventario/inventario-salida/editar-salida.vue'),
    meta: {
      pageTitle: 'Editar Mov. Externo',
      breadcrumb: [
        {
          text: 'Mov. Externo',
          to: '/inventario/salida',
        },
        {
          text: 'Editar Mov. Externo',
          active: true,
        },
      ],
    },
  },
  {
    path: '/inventario/salida/detalle/:id',
    name: 'detalle-mov-ext',
    component: () => import('@/views/inventario/inventario-salida/detalle-salida.vue'),
    meta: {
      pageTitle: 'Detalle Mov. Externo',
      breadcrumb: [
        {
          text: 'Mov. Externo',
          to: '/inventario/salida',
        },
        {
          text: 'Detalle Movimiento',
          active: true,
        },
      ],
    },
  },
  // *===============================================---*
  // *--------- TIPOS ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/tipos/entrada',
    name: 'tipos-entrada',
    component: () => import('@/views/tipos/tipos-entrada/index.vue'),
    meta: {
      pageTitle: 'Movimiento Interno',
      breadcrumb: [
        {
          text: 'Tipos Movimiento Interno',
          active: true,
        },
      ],
    },
  },
  {
    path: '/tipos/salida',
    name: 'tipos-salida',
    component: () => import('@/views/tipos/tipos-salida/index.vue'),
    meta: {
      pageTitle: 'Salida',
      breadcrumb: [
        {
          text: 'Tipos Salida',
          active: true,
        },
      ],
    },
  },
  // *===============================================---*
  // *--------- AUTOPARTES ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/autopartes/listar',
    name: 'autopartes-list',
    component: () => import('@/views/autopartes/autopartes-list/index.vue'),
    meta: {
      pageTitle: 'Listar Autopartes',
      breadcrumb: [
        {
          text: 'Listar',
          active: true,
        },
      ],
    },
  },
  {
    path: '/autopartes/marcas',
    name: 'autopartes-marcas',
    component: () => import('@/views/autopartes/marcas/index.vue'),
    meta: {
      pageTitle: 'Marcas',
      breadcrumb: [
        {
          text: 'Marcas',
          active: true,
        },
      ],
    },
  },
  {
    path: '/autopartes/categorias',
    name: 'autopartes-categorias',
    component: () => import('@/views/autopartes/categorias/index.vue'),
    meta: {
      pageTitle: 'Categorias',
      breadcrumb: [
        {
          text: 'Categorias',
          active: true,
        },
      ],
    },
  },
  {
    path: '/vehiculos',
    name: 'vehiculos-list',
    component: () => import('@/views/vehiculo/index.vue'),
    meta: {
      pageTitle: 'Vehiculos',
      breadcrumb: [
        {
          text: 'Vehiculos',
          active: true,
        },
      ],
    },
  },
  {
    path: '/vehiculos/:id/modelos',
    name: 'vehiculos-modelos',
    component: () => import('@/views/vehiculo/modelos/index.vue'),
    meta: {
      pageTitle: 'Modelos',
      breadcrumb: [
        {
          text: 'Modelos',
          active: true,
        },
      ],
    },
  },
  // *===============================================---*
  // *--------- REPORTES ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/reportes/locales',
    name: 'reportes-locals',
    component: () => import('@/views/reportes/reportes-locales/index.vue'),
    meta: {
      pageTitle: 'Reporte de Locales',
      breadcrumb: [
        {
          text: 'Locales',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reportes/top-productos',
    name: 'reportes-top-products',
    component: () => import('@/views/reportes/reportes-top-productos/index.vue'),
    meta: {
      pageTitle: 'Reporte Top de Productos',
      breadcrumb: [
        {
          text: 'Top de productos',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reportes/mas-menos-vendidos',
    name: 'reportes-products',
    component: () => import('@/views/reportes/reportes-mas-menos-vendidos/index.vue'),
    meta: {
      pageTitle: 'Reporte de Mas y Menos vendidos',
      breadcrumb: [
        {
          text: 'Productos',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reportes/ventas',
    name: 'reportes-ventas',
    component: () => import('@/views/reportes/reportes-ventas/index.vue'),
    meta: {
      pageTitle: 'Reporte de Ventas',
      breadcrumb: [
        {
          text: 'Ventas',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reportes/productos',
    name: 'reportes-autopartes',
    component: () => import('@/views/reportes/reportes-productos/index.vue'),
    meta: {
      pageTitle: 'Reporte por Productos',
      breadcrumb: [
        {
          text: 'Productos',
          active: true,
        },
      ],
    },
  },
  // *===============================================---*
  // *--------- ORDEN DE COMPRA ---- -------------------*
  // *===============================================---*

  // *===================================================*
  // *----------------- IMPORTACION ---------------------*
  // *===================================================*
  {
    path: '/importacion',
    name: 'importacion-list',
    component: () => import('@/views/orden-compra/importacion/index.vue'),
    meta: {
      pageTitle: 'Importación',
      breadcrumb: [
        {
          text: 'Importación',
          active: true,
        },
      ],
    },
  },
  {
    path: '/importacion/:id/detalle',
    name: 'importacion-detalle',
    component: () => import('@/views/orden-compra/importacion/detalle/index.vue'),
    meta: {
      pageTitle: 'Detalle',
      breadcrumb: [
        {
          text: 'Detalle',
          active: true,
        },
      ],
    },
  },

  {
    path: '/contenedores',
    name: 'contenedores-list',
    component: () => import('@/views/contenedores/index.vue'),
    meta: {
      pageTitle: 'Contenedores',
      breadcrumb: [
        {
          text: 'Contenedores',
          active: true,
        },
      ],
    },
  },
  {
    path: '/contenedores/:id/items',
    name: 'items-container',
    component: () => import('@/views/contenedores/items/index.vue'),
    meta: {
      pageTitle: 'Items del contenedor',
      breadcrumb: [
        {
          text: 'Contenedores',
          to: '/contenedores',
        },
        {
          text: 'Items',
          active: true,
        },
      ],
    },
  },
  {
    path: '/contenedores/:id/validar',
    name: 'validar-container',
    component: () => import('@/views/contenedores/validar/index.vue'),
    meta: {
      pageTitle: 'Validar contenedor',
      breadcrumb: [
        {
          text: 'Contenedores',
          to: '/contenedores',
        },
        {
          text: 'Validar',
          active: true,
        },
      ],
    },
  },
  {
    path: '/contenedores/inventario',
    name: 'contenedor-inventario',
    component: () => import('@/views/contenedores/inventario/index.vue'),
    meta: {
      pageTitle: 'Mover a inventario',
      breadcrumb: [
        {
          text: 'Contenedores',
          to: '/contenedores',
        },
        {
          text: 'Inventario',
          active: true,
        },
      ],
    },
  },

  // *===============================================---*
  // *------------------ NACIONAL ----------------------*
  // *===============================================---*

  {
    path: '/nacional',
    name: 'nacional-list',
    component: () => import('@/views/orden-compra/nacional/index.vue'),
    meta: {
      pageTitle: 'Nacional',
      breadcrumb: [
        {
          text: 'Nacional',
          active: true,
        },
      ],
    },
  },
  {
    path: '/nacional/:id/detalle',
    name: 'nacional-detalle',
    component: () => import('@/views/orden-compra/nacional/detalle/index.vue'),
    meta: {
      pageTitle: 'Detalle',
      breadcrumb: [
        {
          text: 'Detalle',
          active: true,
        },
      ],
    },
  },


  // *===============================================---*
  // *------------------ PRESTAMO ----------------------*
  // *===============================================---*

  {
    path: '/prestamo',
    name: 'prestamo-list',
    component: () => import('@/views/prestamo/index.vue'),
    meta: {
      pageTitle: 'Lista de prestamos',
      breadcrumb: [
        {
          text: 'Prestamos',
          active: true,
        },
      ],
    },
  },
  
  {
    path: '/prestamo/agregar',
    name: 'prestamo-add',
    component: () => import('@/views/prestamo/prestamoAdd.vue'),
    meta: {
      pageTitle: 'Agregar Prestamo',
      breadcrumb: [
        {
          text: 'Prestamo',
          active: true,
        },
      ],
    },
  },

  {
    path: '/prestamo/venta/agregar',
    name: 'prestamo-venta-add',
    component: () => import('@/views/venta/prestamo/prestamoVentaAdd.vue'),
    meta: {
      pageTitle: 'Validad Prestamo',
      breadcrumb: [
        {
          text: 'Prestamo',
          active: true,
        },
      ],
    },
  },

  {
    path: '/prestamo/edit/:id',
    name: 'prestamo-edit',
    component: () => import('@/views/prestamo/prestamoEdit.vue'),
    meta: {
      pageTitle: 'Editar Prestamo',
      breadcrumb: [
        {
          text: 'Prestamo',
          active: true,
        },
      ],
    },
  },


  {
    path: '/prestamo/factura/:id',
    name: 'prestamo-factura',
    component: () => import('@/views/prestamo/prestamoFactura.vue'),
    meta: {
      pageTitle: 'Facturación del Prestamo',
      breadcrumb: [
        {
          text: 'Facturación Prestamo',
          active: true,
        },
      ],
    },
  },

  {
    path: '/prestamo/detail/:id',
    name: 'prestamo-detail',
    component: () => import('@/views/prestamo/prestamoDetail.vue'),
    meta: {
      pageTitle: 'Detalle del Prestamo',
      breadcrumb: [
        {
          text: 'Detalle Prestamo',
          active: true,
        },
      ],
    },
  },

  // *===============================================---*
  // *------------------ PROFORMA ----------------------*
  // *===============================================---*

  {
    path: '/proforma',
    name: 'proforma-list',
    component: () => import('@/views/proforma/index.vue'),
    meta: {
      pageTitle: 'Lista de proformas',
      breadcrumb: [
        {
          text: 'Proformas',
          active: true,
        },
      ],
    },
  },
  
  {
    path: '/proforma/agregar',
    name: 'proforma-add',
    component: () => import('@/views/proforma/proformaAdd.vue'),
    meta: {
      pageTitle: 'Agregar Proforma',
      breadcrumb: [
        {
          text: 'Proforma',
          active: true,
        },
      ],
    },
  },

  {
    path: '/proforma/edit/:id',
    name: 'proforma-edit',
    component: () => import('@/views/proforma/proformaEdit.vue'),
    meta: {
      pageTitle: 'Editar Proforma',
      breadcrumb: [
        {
          text: 'Proforma',
          active: true,
        },
      ],
    },
  },

  {
    path: '/proforma/detail/:id',
    name: 'proforma-detail',
    component: () => import('@/views/proforma/proformaDetail.vue'),
    meta: {
      pageTitle: 'Detalle de la Proforma',
      breadcrumb: [
        {
          text: 'Detalle Proforma',
          active: true,
        },
      ],
    },
  },


  // *===============================================---*
  // *------------------ VENTA ----------------------*
  // *===============================================---*

  {
    path: '/venta',
    name: 'venta-list',
    component: () => import('@/views/venta/index.vue'),
    meta: {
      pageTitle: 'Lista de pre-ventas',
      breadcrumb: [
        {
          text: 'Pre-Ventas',
          active: true,
        },
      ],
    },
  },
  
  {
    path: '/venta/agregar',
    name: 'venta-add',
    component: () => import('@/views/venta/ventaAdd.vue'),
    meta: {
      pageTitle: 'Agregar Pre-venta',
      breadcrumb: [
        {
          text: 'Pre-Venta',
          active: true,
        },
      ],
    },
  },

  {
    path: '/caja/agregar',
    name: 'caja-add',
    component: () => import('@/views/venta/caja/cajaAdd.vue'),
    meta: {
      pageTitle: 'Validar Venta',
      breadcrumb: [
        {
          text: 'Venta',
          active: true,
        },
      ],
    },
  },

  {
    path: '/caja/detail/:id',
    name: 'caja-detail',
    component: () => import('@/views/venta/caja/cajaDetail.vue'),
    meta: {
      pageTitle: 'Detalle de la Venta',
      breadcrumb: [
        {
          text: 'Detalle Venta',
          active: true,
        },
      ],
    },
  },

  {
    path: '/venta/detail/:id',
    name: 'venta-detail',
    component: () => import('@/views/venta/ventaDetail.vue'),
    meta: {
      pageTitle: 'Detalle de la Pre-Venta',
      breadcrumb: [
        {
          text: 'Detalle Pre-Venta',
          active: true,
        },
      ],
    },
  },

  {
    path: '/prestamo/venta/',
    name: 'venta-prestamo',
    component: () => import('@/views/venta/prestamo/index.vue'),
    meta: {
      pageTitle: 'Venta del Prestamo',
      breadcrumb: [
        {
          text: 'Venta Prestamo',
          active: true,
        },
      ],
    },
  },

  {
    path: '/venta/caja',
    name: 'venta-caja',
    component: () => import('@/views/venta/caja/index.vue'),
    meta: {
      pageTitle: 'Realizar Venta',
      breadcrumb: [
        {
          text: 'Venta',
          active: true,
        },
      ],
    },
  },

  {
    path: '/finanzas/cargas',
    name: 'finanzas-cargas-list',
    component: () => import('@/views/financial-transaction/list-upload/index.vue'),
    meta: {
      pageTitle: 'Reporte de Cargas',
      breadcrumb: [
        {
          text: 'Cargas',
          active: true,
        },
      ],
    },
  },

  {
    path: '/finanzas',
    name: 'finanzas-list',
    component: () => import('@/views/financial-transaction/financial-list/index.vue'),
    meta: {
      pageTitle: 'Reporte de Transacciones',
      breadcrumb: [
        {
          text: 'Transacciones',
          active: true,
        },
      ],
    },
  },

  {
    path: '/finanzas/graficos',
    name: 'finanzas-graficos',
    component: () => import('@/views/financial-transaction/index.vue'),
    meta: {
      pageTitle: 'Gráficos Financieros',
      breadcrumb: [
        {
          text: 'Gráficos',
          active: true,
        },
      ],
    },
  },

   // *===============================================---*
  // *------------------ EXCELS ----------------------*
  // *===============================================---*

  {
    path: '/excel/importacion',
    name: 'excel-importacion-list',
    component: () => import('@/views/excel/importacion/index.vue'),
    meta: {
      pageTitle: 'Lista de Importación de Excel',
      breadcrumb: [
        {
          text: 'Importación de Excel',
          active: true,
        },
      ],
    },
  },

  {
    path: '/excel/stock',
    name: 'excel-stock-list',
    component: () => import('@/views/excel/stock/index.vue'),
    meta: {
      pageTitle: 'Lista de Stock de Excel',
      breadcrumb: [
        {
          text: 'Stock de Excel',
          active: true,
        },
      ],
    },
  },
  // *===============================================---*
  // *------------------ IMPORT BATCH ------------------*
  // *===============================================---*

  {
    path: '/importacion-batch',
    name: 'importacion-batch-list',
    component: () => import('@/views/import/index.vue'),
    meta: {
      pageTitle: 'Lista de Importación corregido',
      breadcrumb: [
        {
          text: 'Importación de Excel corregido',
          active: true,
        },
      ],
    },
  },

  // *===============================================---*
  // *------------------ File Upload ------------------*
  // *===============================================---*

  {
    path: '/file-upload-batch',
    name: 'file-upload-batch-list',
    component: () => import('@/views/recon-match/fileUpload.vue'),
    meta: {
      pageTitle: 'Lista de Excel importación - venta',
      breadcrumb: [
        {
          text: 'Importación - Venta',
          active: true,
        },
      ],
    },
  },

  // *===============================================---*
  // *----------------- Recon Matching -----------------*
  // *===============================================---*

  {
    path: '/recon-matching',
    name: 'recon-matching-list',
    component: () => import('@/views/recon-match/reconMatching.vue'),
    meta: {
      pageTitle: 'Lista de Venta match',
      breadcrumb: [
        {
          text: 'Venta match importación',
          active: true,
        },
      ],
    },
  },

]
